import { render, staticRenderFns } from "./huay-list-detail.vue?vue&type=template&id=2979da4d&scoped=true"
import script from "./huay-list-detail.vue?vue&type=script&lang=js"
export * from "./huay-list-detail.vue?vue&type=script&lang=js"
import style0 from "./huay-list-detail.vue?vue&type=style&index=0&id=2979da4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2979da4d",
  null
  
)

export default component.exports